module.exports = __webpack_public_path__ + "img/mullinl.575e5a18.jpg";